// extracted by mini-css-extract-plugin
module.exports = {"p10":"_b96430","p25":"_b90209","p50":"_60e0af","p75":"_ab096d","p90":"_0411db","p100":"_90ce16"};